"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const canvas_1 = require("canvas");
const constants_1 = require("../../constants");
const colours_module_scss_1 = __importDefault(require("../../styles/colours.module.scss"));
require("./BarChart.scss");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const Expander_1 = __importDefault(require("../Expander"));
const CanvasDrawer_1 = __importDefault(require("../../util/CanvasDrawer"));
const chart_helpers_1 = require("../../util/chart.helpers");
const Tooltip_1 = __importDefault(require("../Tooltip"));
const InfoTooltip_1 = __importDefault(require("../InfoTooltip"));
const SourcesAndFootnotes_1 = __importDefault(require("../SourcesAndFootnotes"));
const error_1 = require("../error");
const transitions_1 = require("../../util/transitions");
class BarChart extends Expander_1.default {
  constructor(container, cssPrefix) {
    super(container, 1000, 300, cssPrefix || 'bar-chart', false);
    this.chartType = constants_1.CHART_TYPES.BarChart;
    this.cssPrefix = cssPrefix || 'bar-chart';
    this.initialDraw = true;
    this.overrideDataSelector = null;
    this.margins = {
      top: 20,
      bottom: 20,
      left: 10,
      right: 35,
      labelPadding: 20,
      valueLabelPadding: 10,
      maxLabelWidth: null
    };
    this.ySpacing = 30;
    this.dropdownSelected = null;
    if (container === undefined) {
      return;
    }
    this.title = container.insert('div', 'div.expandable').classed('chart-title', true);
    this.subtitle = container.insert('div', 'div.expandable').classed('chart-subtitle', true);
    this.sourceContainer = container.append('div');
    this.sources = new SourcesAndFootnotes_1.default(this.sourceContainer);
    this.tooltip = new Tooltip_1.default(container);
    this.initGroups();
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        const {
          width: containerWidth
        } = entry.contentRect;
        requestAnimationFrame(() => {
          this.resizeContent(containerWidth);
        });
      });
    });
    this.ro.observe(container.node());
  }
  initGroups() {
    this.svg.append('g').classed('axis', true).classed(`${this.cssPrefix}-xaxis`, true);
    this.svg.append('g').classed('axis', true).classed(`${this.cssPrefix}-xline`, true);
    const chartGroup = this.svg.append('g').classed(`${this.cssPrefix}-chart`, true);
    chartGroup.append('rect').classed(`${this.cssPrefix}-touch-area`, true);
    chartGroup.append('g').classed(`${this.cssPrefix}-labels`, true);
    chartGroup.append('g').classed(`${this.cssPrefix}-area`, true);
    this.initExpand();
    error_1.initError.call(this);
  }
  static isTopOrBottom(i, _ref) {
    let {
      data = [],
      topMetrics = [],
      bottomMetrics = []
    } = _ref;
    return i < topMetrics.length || i >= data.length + topMetrics.length - bottomMetrics.length;
  }
  createScales(data, params, margins, metricHeight) {
    let topMetrics = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    let bottomMetrics = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    const sectionSpacing = 10;
    const [minValue, maxValue] = d3.extent((0, chart_helpers_1.allDataPoints)(lodash_1.default.flattenDeep([data, topMetrics, bottomMetrics]), params.startDate, params.endDate, data[0] ? data[0].metric.xType : 'years'), d => d.value);
    let dataXDomain = [Math.min(0, minValue), Math.max(0, maxValue)];
    if (params.floatingAxis) {
      // finds the extremes for data with the selected key
      const [keyMinValue, keyMaxValue] = d3.extent(lodash_1.default.filter((0, chart_helpers_1.allDataPoints)(lodash_1.default.flattenDeep([data, topMetrics, bottomMetrics]), params.startDate, params.endDate, data[0] ? data[0].metric.xType : 'years'), d => BarChart.keyMatches(d.key, this.dropdownSelected, d.metric.metric.xType)), d => d.value);
      dataXDomain = [Math.min(0, keyMinValue), Math.max(0, keyMaxValue)];
    }
    let xScale = d3.scaleLinear().domain(dataXDomain);
    if (params.niceScale) {
      xScale.nice();
    }
    if (params.domain !== null) {
      xScale = d3.scaleLinear().domain(params.domain);
    }
    let startY = margins.top;
    let ySpacing = metricHeight;
    let topMetricYScale;
    let bottomMetricYScale;
    if (params.autosize !== false) {
      const chartHeight = this.chartArea(0, data, params).height;
      const sectionsSpacing = (topMetrics.height ? sectionSpacing : 0) + (bottomMetrics.height ? sectionSpacing : 0);
      const defaultNumMetrics = data.length + 1 + topMetrics.length + bottomMetrics.length;
      const numMetrics = Number.isFinite(params.autosize) && params.autosize > 0 ? Math.max(params.autosize + 1, defaultNumMetrics) : defaultNumMetrics;
      this.ySpacing = (chartHeight - sectionsSpacing) / numMetrics;
      ySpacing = this.ySpacing;
    }
    const metricSorter = d => {
      const maxSet = d.metric.data.find(v => BarChart.keyMatches(v.key, this.dropdownSelected, d.metric.xType));
      return maxSet && Number.isFinite(maxSet.value) ? maxSet.value : -Infinity;
    };
    const newTopMetrics = !params.sortRows ? topMetrics : (0, lodash_1.default)(topMetrics).orderBy(metricSorter, 'desc').value();
    const newBottomMetrics = !params.sortRows ? bottomMetrics : (0, lodash_1.default)(bottomMetrics).orderBy(metricSorter, 'desc').value();
    const newData = !params.sortRows ? data : (0, lodash_1.default)(data).orderBy(metricSorter, 'desc').value();
    if (newTopMetrics.length) {
      topMetricYScale = d3.scaleBand().paddingInner(0.2).domain(newTopMetrics.map(this.dataSelector.bind(this))).range([startY, startY + newTopMetrics.length * ySpacing]);
      startY += newTopMetrics.length * ySpacing + sectionSpacing;
    }
    const mainMetricYScale = d3.scaleBand().paddingInner(0.2).domain(newData.map(this.dataSelector.bind(this))).range([startY, startY + data.length * ySpacing]);
    startY += newData.length * ySpacing;
    if (newBottomMetrics.length) {
      startY += sectionSpacing;
      bottomMetricYScale = d3.scaleBand().paddingInner(0.2).domain(newBottomMetrics.map(this.dataSelector.bind(this))).range([startY, startY + newBottomMetrics.length * ySpacing]);
      startY += newBottomMetrics.length * ySpacing;
    }
    const yScale = d => {
      if (topMetricYScale && Number.isFinite(topMetricYScale(d))) {
        return topMetricYScale(d);
      }
      if (bottomMetricYScale && Number.isFinite(bottomMetricYScale(d))) {
        return bottomMetricYScale(d);
      }
      return mainMetricYScale(d);
    };
    yScale.range = () => [margins.top, startY];
    yScale.bandwidth = () => mainMetricYScale.bandwidth();
    return {
      xScale,
      yScale
    };
  }
  dataSelector(d) {
    return this.overrideDataSelector ? this.overrideDataSelector(d) : (0, chart_helpers_1.uniqueMetricMap)(d);
  }
  chartArea(leftPadding, data, params) {
    return {
      width: this.width - params.margins.right - (leftPadding || 0),
      height: this.height(data, params) - params.margins.top - params.margins.bottom
    };
  }
  longestBarValueLabelLength(data, drawParams, onLeft) {
    const {
      params
    } = drawParams;
    const labelMode = (0, chart_helpers_1.getLabelTextMode)(data.filter((d, i) => !BarChart.isTopOrBottom(i, drawParams)), params);
    const format = (0, chart_helpers_1.valueFormat)(drawParams);
    const valueText = d => {
      if (params.labelAsValueLabel) {
        return BarChart.getValueLabelText(d, labelMode);
      }
      const value = this.valueAccessor(d);
      return Number.isFinite(value) ? format(value) : '';
    };
    let filteredData;
    if (onLeft) {
      filteredData = data.filter(d => this.valueAccessor(d) < 0);
    } else {
      filteredData = data.filter(d => this.valueAccessor(d) >= 0);
    }
    if (filteredData.length === 0) {
      return 0;
    }
    const barWidthEstimates = filteredData.map(d => this.widthAccessor(d));
    const filteredTitles = filteredData.map(d => valueText(d));
    const textWidths = [];
    const dummyG = this.svg.append('g');
    dummyG.selectAll('.dummyText').data(filteredTitles).enter().append('text').style('font-size', `${params.fontSize}px`).attr('opacity', 0).text(d => d).each(function () {
      const thisWidth = this.getComputedTextLength();
      textWidths.push(thisWidth);
      this.remove();
    });
    const totalBarWidths = lodash_1.default.map(textWidths, (d, i) => d + barWidthEstimates[i]);
    dummyG.remove();
    return textWidths[lodash_1.default.indexOf(totalBarWidths, Math.max(...totalBarWidths))];
  }
  headerHeight() {
    return this.title.node().getBoundingClientRect().height + this.subtitle.node().getBoundingClientRect().height;
  }
  extraUIHeight() {
    return this.headerHeight() + this.sourceContainer.node().getBoundingClientRect().height;
  }
  dataHeight(data) {
    return (data.length + 1) * this.ySpacing + this.margins.top + this.margins.bottom;
  }
  height(data, params) {
    if (params.autosize) {
      return this.container.node().getBoundingClientRect().height - this.extraUIHeight();
    }
    return this.dataHeight(data);
  }
  showTooltip(drawParams, d, key, leftPad, colour) {
    const containerDim = this.container.node().getBoundingClientRect();
    const svgDim = this.svg.node().getBoundingClientRect();
    const barD = this.valueAccessor(d);
    if (barD === null || barD === undefined) {
      return;
    }
    const x = leftPad + this.xAccessor(d) + this.widthAccessor(d) / 2;
    const y = svgDim.top - containerDim.top + this.yAccessor(d);
    const dataLabel = (d.metric.lexiconName || d.metric.name) + (d.metric.geo_id && d.metric.geo_id !== 'US' ? ` in ${d.metric.geo_name}` : '');
    const format = (0, chart_helpers_1.tooltipFormat)(drawParams);
    const topContent = {
      title: {
        value: d.tooltipTitle ?? dataLabel
      },
      subtitle: {
        value: key
      }
    };
    this.tooltip.draw(x, y, topContent, [{
      type: 'value',
      value: format(barD)
    }], {
      primaryColour: colour
    });
  }
  async data(promises, options) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    const {
      data,
      topMetrics,
      bottomMetrics,
      parent
    } = fetched;
    let filtered = data.filter(d => d.metric.data && d.metric.data.length > 0);
    const startDate = options.startDate || options.startYear;
    const endDate = options.endDate || options.endYear;
    const dateFilter = date => {
      if (date.xType === 'items') return true;
      if (startDate && date.key.getTime() < (0, chart_helpers_1.dateParser)(startDate, date.xType).getTime()) {
        return false;
      }
      if (endDate && date.key.getTime() > (0, chart_helpers_1.dateParser)(endDate, date.xType).getTime()) {
        return false;
      }
      return true;
    };
    let keysAreDates = true;
    const getKeys = d => {
      if (d.metric.xType && d.metric.xType.toLowerCase() === 'items') keysAreDates = false;
      return d.metric.data.map(_ref2 => {
        let {
          key
        } = _ref2;
        return {
          key,
          xType: d.metric.xType
        };
      });
    };
    let keys = (0, lodash_1.default)(filtered).flatMap(getKeys).filter(dateFilter);
    if (keysAreDates) {
      keys = keys.sortBy('key').map(date => (0, chart_helpers_1.dateFormat)(date.key, date.xType));
    }
    keys = keys.uniq().value();
    let overlappingKeys = (0, lodash_1.default)(filtered).map(getKeys).thru(k => lodash_1.default.intersectionWith(...k, (a, b) => {
      if (!keysAreDates) return a.key === b.key;
      return a.key.getTime() === b.key.getTime();
    })).filter(dateFilter);
    if (keysAreDates) {
      overlappingKeys = overlappingKeys.sortBy('key').map(date => (0, chart_helpers_1.dateFormat)(date.key, date.xType));
    }
    if (this.dropdownSelected === null || !keys.includes(this.dropdownSelected)) {
      if (options.selectedYear !== undefined && keys.includes(options.selectedYear.toString())) {
        this.dropdownSelected = options.selectedYear;
      } else if (options.selectedDropdown !== undefined && keys.includes(options.selectedDropdown.toString())) {
        this.dropdownSelected = options.selectedDropdown;
      } else if (options.defaultToOverlapYears) {
        this.dropdownSelected = lodash_1.default.last(overlappingKeys.value());
      } else if (!keysAreDates) {
        this.dropdownSelected = lodash_1.default.first(keys);
      } else {
        this.dropdownSelected = lodash_1.default.last(keys);
      }
    }
    if (options.forceYear && keys.includes(options.forceYear.toString())) {
      this.dropdownSelected = options.forceYear;
    }
    if (options.forceDropdown && keys.includes(options.forceDropdown.toString())) {
      this.dropdownSelected = options.forceDropdown;
    }
    const shouldSort = options.sortRows !== undefined ? options.sortRows : true;
    const metricSorter = d => {
      const maxSet = d.metric.data.find(v => BarChart.keyMatches(v.key, this.dropdownSelected, d.metric.xType));
      return maxSet && Number.isFinite(maxSet.value) ? maxSet.value : -Infinity;
    };
    filtered = !shouldSort ? filtered : (0, lodash_1.default)(filtered).orderBy(metricSorter, 'desc').value();
    return {
      data: filtered,
      topMetrics: topMetrics || [],
      bottomMetrics: bottomMetrics || [],
      parent,
      keys
    };
  }
  getDrawParams(_ref3) {
    let {
      data,
      parent,
      options: {
        hideAxisLabels = true,
        hideGridlines = true,
        selectableYears = true,
        selectableDropdowns = true,
        sortRows = true,
        primaryColor = colours_module_scss_1.default.chartcolourdefault0,
        axisTextColor = null,
        gridColor = null,
        labelColor = null,
        metricHeight = data[0].allStates === true ? 17 : 30,
        autosize = false,
        defaultToOverlapYears = false,
        positiveColour = null,
        negativeColour = null,
        bottomXTicks = false,
        xAxisTicks = 5,
        expanded = false,
        uncollapsible = false,
        hideDrawLine = false,
        selectedMetrics = [],
        labelAsValueLabel = false,
        hideLabels = false,
        transition = false,
        transitionDuration = 1000,
        hideYear = false,
        hideDropdown = false,
        domain = null,
        floatingAxis = true,
        niceScale = true,
        hideSeparator = false,
        dataSelector = null,
        hideTitle = false,
        showSourcesAndFootnotes = true,
        ...otherOptions
      }
    } = _ref3;
    return {
      ...(0, chart_helpers_1.getDefaultDrawParams)({
        data,
        parent,
        options: otherOptions
      }, this.margins),
      hideAxisLabels,
      hideGridlines,
      selectableYears,
      selectableDropdowns,
      sortRows,
      primaryColor,
      axisTextColor,
      gridColor,
      labelColor,
      metricHeight,
      autosize,
      defaultToOverlapYears,
      positiveColour,
      negativeColour,
      bottomXTicks,
      xAxisTicks,
      expanded,
      uncollapsible,
      hideDrawLine,
      selectedMetrics,
      labelAsValueLabel,
      hideLabels,
      transition,
      transitionDuration,
      hideYear,
      hideDropdown,
      domain,
      floatingAxis,
      niceScale,
      hideSeparator,
      dataSelector,
      hideTitle,
      showSourcesAndFootnotes
    };
  }
  static getValueLabelText(d, labelMode) {
    return (0, chart_helpers_1.getStateAbbreviation)((0, chart_helpers_1.getLabelText)(d, labelMode));
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) return false;
    const {
      data,
      topMetrics,
      bottomMetrics,
      parent,
      keys
    } = allData;
    const optionParams = this.getDrawParams({
      data,
      parent,
      options
    });
    const drawParams = {
      data,
      topMetrics,
      bottomMetrics,
      parent,
      keys,
      params: optionParams
    };
    this.overrideDataSelector = optionParams.dataSelector;
    this.hasPosNegColours = optionParams.positiveColour !== null && optionParams.negativeColour !== null;
    if (optionParams.titleVerticalPosition === 'top') {
      this.title.classed('below', false);
      this.container.node().insertBefore(this.title.node(), this.svg.node().parentNode);
      this.container.node().insertBefore(this.subtitle.node(), this.svg.node().parentNode);
    } else if (optionParams.titleVerticalPosition === 'bottom') {
      this.title.classed('below', true);
      this.container.node().append(this.title.node());
      this.container.node().append(this.subtitle.node());
      this.container.node().append(this.sourceContainer.node());
    }
    this.drawContent(drawParams);
    return true;
  }
  setDropdownSelected(key) {
    this.dropdownSelected = key;
  }
  resizeContent(newWidth) {
    if (this.cachedParams && (this.cachedParams.params.autosize !== false || this.width !== newWidth)) {
      const {
        data,
        params
      } = this.cachedParams;
      this.drawContent(this.cachedParams, false);
      this.trigger('resize', {
        width: newWidth,
        height: this.height(data, params),
        headerHeight: this.headerHeight(),
        extraUIHeight: this.extraUIHeight(),
        dataHeight: this.dataHeight(data)
      });
    }
  }
  setHovered(hovered) {
    if (this.cachedParams) {
      const entries = this.svg.select(`g.${this.cssPrefix}-area`).selectAll(`g.${this.cssPrefix}-entry`);
      entries.style('opacity', (d, i) => this.entryOpacity(d, i, this.cachedParams, hovered));
      entries.selectAll('.entry-value-label').style('display', d => {
        if (this.displayCheck(d, this.cachedParams.params) === null || this.dataSelector(d) === hovered) {
          return null;
        }
        return 'none';
      });
    }
  }
  redrawContent() {
    if (this.cachedParams) {
      this.drawContent(this.cachedParams);
    }
  }
  drawContent(drawParams) {
    let overrideTransition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const oldParams = lodash_1.default.cloneDeep(this.cachedParams);
    this.cachedParams = drawParams;
    const {
      data,
      topMetrics,
      bottomMetrics,
      params
    } = drawParams;
    const shouldTransition = overrideTransition ?? params.transition;
    this.width = this.container.node().getBoundingClientRect().width;
    this.ySpacing = params.metricHeight;
    const topData = topMetrics || [];
    const combinedData = lodash_1.default.concat(topData, data, bottomMetrics);
    const paramsWithSorted = {
      ...drawParams,
      data: combinedData
    };
    if (!params.hideTitle) {
      chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, paramsWithSorted, params.hideYear || params.hideDropdown ? null : this.dropdownSelected);
    }
    if (params.showSourcesAndFootnotes) {
      this.sources.draw(combinedData, params);
    }
    const {
      xScale,
      yScale
    } = this.createScales.call(this, data, params, params.margins, this.ySpacing, topMetrics, bottomMetrics);
    this.xScale = xScale;
    this.yScale = yScale;
    if (!params.hideSeparator) {
      // pass original drawParams to keep sections separated
      this.drawSectionLines(drawParams, shouldTransition);
    }
    this.drawEntries(paramsWithSorted, shouldTransition);
    this.drawAxis(paramsWithSorted, shouldTransition);
    const touchHeight = this.expanderSection.node().getBoundingClientRect().height || this.yScale.range()[1] - this.yScale.range()[0] + this.yScale.bandwidth();
    this.svg.select(`.${this.cssPrefix}-touch-area`).attr('x', 0).attr('y', 0).attr('width', this.width).attr('height', touchHeight).on('click', () => {
      if ('ontouchstart' in window) {
        this.tooltip.hide();
      }
    }, {
      passive: true
    });
    if (params.info && params.info.position === 'chart') {
      InfoTooltip_1.default.inChart(this.container, params);
    }
    this.initialDraw = false;
    this.drawExpander(combinedData, params, () => this.drawContent(drawParams));
    if (oldParams && (Number.isFinite(params.autosize) || params.autosize !== oldParams.autosize)) {
      this.trigger('resize', {
        width: this.width,
        height: this.height(data, params),
        headerHeight: this.headerHeight(),
        extraUIHeight: this.extraUIHeight(),
        dataHeight: this.dataHeight(data)
      });
    }
  }
  static keyMatches(d, selected, xType) {
    if (xType && xType.toLowerCase() === 'items') {
      return d === selected;
    }
    if (!selected.getTime) {
      return d.getTime() === (0, chart_helpers_1.dateParser)(selected, xType).getTime();
    }
    return d.getTime() === selected.getTime();
  }
  valueAccessor(d) {
    const set = d.metric.data.find(v => BarChart.keyMatches(v.key, this.dropdownSelected, d.metric.xType));
    return set ? set.value : null;
  }
  xAccessor(d) {
    return this.xScale(Math.min(0, this.valueAccessor(d)));
  }
  widthAccessor(d) {
    return Math.abs(this.xScale(this.valueAccessor(d)) - this.xScale(0));
  }
  yAccessor(d) {
    return this.yScale(this.dataSelector(d)) + this.yScale.bandwidth();
  }
  posNegColours(params, d) {
    if (this.xAccessor(d) === this.xScale(0)) {
      return params.positiveColour;
    }
    return params.negativeColour;
  }
  displayCheck(d, params) {
    if (params.selectedMetrics && params.selectedMetrics.length > 0) {
      if (lodash_1.default.includes(params.selectedMetrics, this.dataSelector(d))) {
        return null;
      }
      return 'none';
    }
    return null;
  }
  entryOpacity(d, i, _ref4, hovered) {
    let {
      data,
      topMetrics,
      bottomMetrics,
      params
    } = _ref4;
    const someSelectedStates = lodash_1.default.some(data, dd => dd.selectedState);
    if (!someSelectedStates && (!params.selectedMetrics || params.selectedMetrics.length === 0)) {
      return 1;
    }
    if (params.selectedMetrics && params.selectedMetrics.includes(this.dataSelector(d)) || this.dataSelector(d) === hovered || BarChart.isTopOrBottom(i, {
      data,
      topMetrics,
      bottomMetrics
    })) {
      return 1;
    }
    return 0.4;
  }
  entryColour(d, params) {
    const defaultReturn = d.primaryColor || (this.hasPosNegColours ? this.posNegColours(params, d) : (0, chart_helpers_1.primaryColour)(params, d));
    if (params.selectedMetrics.length > 0) {
      if (lodash_1.default.includes(params.selectedMetrics, this.dataSelector(d))) {
        return defaultReturn;
      }
      return colours_module_scss_1.default.chartcolourgrey;
    }
    return defaultReturn;
  }
  valueLabelColour(d, params) {
    if (d.labelColor) {
      return d.labelColor;
    }
    if (this.hasPosNegColours) {
      if (this.valueAccessor(d) >= 0) {
        return params.positiveColour;
      }
      return params.negativeColour;
    }
    return params.labelColor;
  }
  tooltipColour(d, params) {
    return this.hasPosNegColours ? this.posNegColours(params, d) : (0, chart_helpers_1.primaryColour)(params, d);
  }
  ellipsizeWidth(_ref5) {
    let {
      data,
      params
    } = _ref5;
    const hasCustomLabels = lodash_1.default.some(data, d => d.labelText !== undefined);
    const reactiveWidth = this.width * (hasCustomLabels ? 0.5 : 0.4);
    if (params.margins.maxLabelWidth !== null) {
      return Math.min(params.margins.maxLabelWidth, reactiveWidth);
    }
    return reactiveWidth;
  }
  drawEntries(drawParams) {
    let transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const {
      data,
      params
    } = drawParams;
    const labelMode = (0, chart_helpers_1.getLabelTextMode)(data.filter((d, i) => !BarChart.isTopOrBottom(i, drawParams)), params);
    // DRAW LEFT LABELS
    const chartAreaLeft = this.drawEntryLabels(drawParams, labelMode, transition);
    const area = this.chartArea(chartAreaLeft, data, params);
    this.xScale.range([0, area.width]);
    const chartGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    const chartAreaGroup = chartGroup.select(`g.${this.cssPrefix}-area`);
    const leftValueLabelOffset = this.longestBarValueLabelLength(data, drawParams, true);
    const rightValueLabelOffset = this.longestBarValueLabelLength(data, drawParams, false);
    chartAreaGroup.attr('transform', `translate(${chartAreaLeft}, 0)`);
    if (area.width - rightValueLabelOffset - leftValueLabelOffset > 0) {
      this.xScale.range([leftValueLabelOffset + params.margins.valueLabelPadding, area.width - rightValueLabelOffset - params.margins.valueLabelPadding]);
    }
    const entriesUpdate = chartAreaGroup.selectAll(`g.${this.cssPrefix}-entry`).data(data, d => this.dataSelector(d)).on('mousemove', lodash_1.default.throttle((event, d) => {
      this.showTooltip(drawParams, d, this.dropdownSelected, chartAreaLeft, this.tooltipColour(d, params));
      // set group opacity and value label display
      this.setHovered(this.dataSelector(d));
      this.trigger('hover', d);
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
      this.setHovered();
      this.trigger('mouseout');
    }, {
      passive: true
    }).on('click', (event, d) => {
      this.trigger('click', d);
    }, {
      passive: true
    });
    const entriesEnter = entriesUpdate.enter().append('g').classed(`${this.cssPrefix}-entry`, true).style('opacity', (d, i) => this.entryOpacity(d, i, drawParams)).on('mousemove', lodash_1.default.throttle((event, d) => {
      this.showTooltip(drawParams, d, this.dropdownSelected, chartAreaLeft, this.tooltipColour(d, params));
      this.setHovered(this.dataSelector(d));
      this.trigger('hover', d);
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
      this.setHovered();
      this.trigger('mouseout');
    }, {
      passive: true
    }).on('click', (event, d) => {
      this.trigger('click', d);
    }, {
      passive: true
    });
    const entriesExit = entriesUpdate.exit();
    const selections = {
      enter: entriesEnter,
      update: entriesUpdate,
      exit: entriesExit
    };
    // DRAW RECTS AND VALUE LABELS
    this.drawEntryRects(drawParams, selections, transition);
    this.drawEntryValueLabels(drawParams, selections, labelMode, transition);
    if (transition && !this.initialDraw) {
      entriesUpdate.transition((0, transitions_1.immediateTransition)(params)).style('opacity', (d, i) => this.entryOpacity(d, i, drawParams));
      entriesExit.transition((0, transitions_1.immediateTransition)(params)).remove();
    } else {
      entriesUpdate.style('opacity', (d, i) => this.entryOpacity(d, i, drawParams));
      entriesExit.remove();
    }
    chartAreaGroup.selectAll(`g.${this.cssPrefix}-entry`).style('cursor', this.hasAction('click') ? 'pointer' : null);
    return chartAreaLeft;
  }
  drawEntryLabels(drawParams, labelMode) {
    let transition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const {
      data,
      params
    } = drawParams;
    const chart = this;
    const chartGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    const chartLabelGroup = chartGroup.select(`g.${this.cssPrefix}-labels`).attr('transform', `translate(${params.margins.left}, 0)`);
    const labelUpdate = chartLabelGroup.selectAll('text.entry-label').data(data, d => this.dataSelector(d));
    const labelEnter = labelUpdate.enter().append('text').classed('entry-label', true).style('font-size', `${params.fontSize}px`).text(d => (0, chart_helpers_1.getLabelText)(d, labelMode)).each(function () {
      (0, chart_helpers_1.ellipsize)(d3.select(this), chart.ellipsizeWidth(drawParams));
    });
    const labelExit = labelUpdate.exit();
    const setLabelEnterAttrs = selection => {
      selection.attr('y', d => this.yAccessor(d)).style('fill', d => d.labelColor || params.labelColor).style('font-size', `${params.fontSize}px`).style('display', params.hideLabels ? 'none' : null).style('opacity', 0);
    };
    const labelEnterTransition = selection => {
      selection.style('opacity', (d, i) => this.entryOpacity(d, i, drawParams));
    };
    const labelUpdateTransition = selection => {
      selection.attr('y', d => this.yAccessor(d)).style('fill', d => d.labelColor || params.labelColor).style('font-size', `${params.fontSize}px`).style('display', params.hideLabels ? 'none' : null).style('opacity', (d, i) => this.entryOpacity(d, i, drawParams));
    };
    if (transition && !this.initialDraw) {
      labelEnter.call(setLabelEnterAttrs).transition((0, transitions_1.delayedTransition)(params)).call(labelEnterTransition);
      labelUpdate.text(d => (0, chart_helpers_1.getLabelText)(d, labelMode)).each(function () {
        (0, chart_helpers_1.ellipsize)(d3.select(this), chart.ellipsizeWidth(drawParams));
      }).transition((0, transitions_1.delayedTransition)(params)).call(labelUpdateTransition);
      labelExit.transition((0, transitions_1.immediateTransition)(params)).call(transitions_1.fadeOut).remove();
    } else {
      labelEnter.call(setLabelEnterAttrs).call(labelEnterTransition);
      labelUpdate.text(d => (0, chart_helpers_1.getLabelText)(d, labelMode)).each(function () {
        (0, chart_helpers_1.ellipsize)(d3.select(this), chart.ellipsizeWidth(drawParams));
      }).call(labelUpdateTransition);
      labelExit.remove();
    }
    const chartAreaLeft = params.margins.left + params.margins.labelPadding + chartLabelGroup.node().getBBox().width;
    labelUpdate.on('mousemove', lodash_1.default.throttle((event, d) => {
      this.showTooltip(drawParams, d, this.dropdownSelected, chartAreaLeft, this.tooltipColour(d, params));
      this.setHovered(this.dataSelector(d));
      this.trigger('hover', d);
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
      this.setHovered();
      this.trigger('mouseout');
    }, {
      passive: true
    }).on('click', (event, d) => {
      this.trigger('click', d);
    }, {
      passive: true
    });
    labelEnter.on('mousemove', lodash_1.default.throttle((event, d) => {
      this.showTooltip(drawParams, d, this.dropdownSelected, chartAreaLeft, this.tooltipColour(d, params));
      this.setHovered(this.dataSelector(d));
      this.trigger('hover', d);
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
      this.setHovered();
      this.trigger('mouseout');
    }, {
      passive: true
    }).on('click', (event, d) => {
      this.trigger('click', d);
    }, {
      passive: true
    });
    return chartAreaLeft;
  }
  drawEntryRects(_ref6, _ref7) {
    let {
      params
    } = _ref6;
    let {
      enter,
      update,
      exit
    } = _ref7;
    let transition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    enter.append('rect').classed('entry-rect', true);
    const rectUpdate = update.select('.entry-rect');
    const rectEnter = enter.select('.entry-rect');
    const rectExit = exit.select('.entry-rect');
    const setRectEnterAttrs = selection => {
      selection.attr('width', d => this.widthAccessor(d)).attr('height', this.yScale.bandwidth()).attr('fill', d => this.entryColour(d, params)).attr('x', d => this.xAccessor(d)).attr('y', d => this.yAccessor(d) - this.yScale.bandwidth() / 2).style('opacity', 0);
    };
    const rectUpdateFirstTransition = selection => {
      selection.attr('x', d => this.xAccessor(d)).attr('width', d => this.widthAccessor(d)).attr('height', this.yScale.bandwidth()).style('opacity', 1);
    };
    const rectUpdateSecondTransition = selection => {
      selection.attr('y', d => this.yAccessor(d) - this.yScale.bandwidth() / 2);
    };
    if (transition && !this.initialDraw) {
      rectEnter.call(setRectEnterAttrs).transition((0, transitions_1.delayedTransition)(params)).call(transitions_1.fadeIn);
      rectUpdate.attr('fill', d => this.entryColour(d, params)).transition((0, transitions_1.immediateTransition)(params)).call(rectUpdateFirstTransition).transition((0, transitions_1.immediateTransition)(params)).call(rectUpdateSecondTransition);
      rectExit.transition((0, transitions_1.immediateTransition)(params)).call(transitions_1.fadeOut);
    } else {
      rectEnter.call(setRectEnterAttrs).call(transitions_1.fadeIn);
      rectUpdate.attr('fill', d => this.entryColour(d, params)).call(rectUpdateFirstTransition).call(rectUpdateSecondTransition);
    }
  }
  drawEntryValueLabels(drawParams, _ref8, labelMode) {
    let {
      enter,
      update,
      exit
    } = _ref8;
    let transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const {
      params
    } = drawParams;
    const format = (0, chart_helpers_1.valueFormat)(drawParams);
    const valueText = d => {
      if (params.labelAsValueLabel) {
        return BarChart.getValueLabelText(d, labelMode);
      }
      const value = this.valueAccessor(d);
      return Number.isFinite(value) ? format(value) : '';
    };
    enter.append('text').classed('entry-value-label', true);
    const valueLabelUpdate = update.select('.entry-value-label');
    const valueLabelEnter = enter.select('.entry-value-label');
    const valueLabelExit = exit.select('.entry-value-label');
    const setValueLabelEnterAttrs = selection => {
      selection.attr('x', d => {
        const curVal = this.valueAccessor(d);
        if (curVal < 0) {
          return this.xScale(curVal) - params.margins.valueLabelPadding;
        }
        const rightValue = this.xScale(Math.max(0, curVal));
        return rightValue + params.margins.valueLabelPadding;
      }).attr('text-anchor', d => {
        if (this.valueAccessor(d) < 0) {
          return 'end';
        }
        return 'start';
      }).attr('y', d => this.yAccessor(d)).style('fill', d => {
        if (this.displayCheck(d, params) === 'none') {
          return colours_module_scss_1.default.chartcolourgrey;
        }
        return this.valueLabelColour(d, params);
      }).style('font-size', `${params.fontSize}px`).style('display', d => this.displayCheck(d, params)).text(d => valueText(d)).style('opacity', 0);
    };
    const valueLabelUpdateFirstTransition = selection => {
      selection.attr('x', d => {
        const curVal = this.valueAccessor(d);
        if (curVal < 0) {
          return this.xScale(curVal) - params.margins.valueLabelPadding;
        }
        const rightValue = this.xScale(Math.max(0, curVal));
        return rightValue + params.margins.valueLabelPadding;
      }).attr('text-anchor', d => {
        if (this.valueAccessor(d) < 0) {
          return 'end';
        }
        return 'start';
      }).style('fill', d => {
        if (this.displayCheck(d, params) === 'none') {
          return colours_module_scss_1.default.chartcolourgrey;
        }
        return this.valueLabelColour(d, params);
      }).style('font-size', `${params.fontSize}px`).style('display', d => this.displayCheck(d, params)).style('opacity', 1).text(d => valueText(d));
    };
    const valueLabelUpdateSecondTransition = selection => {
      selection.attr('y', d => this.yAccessor(d));
    };
    if (transition && !this.initialDraw) {
      valueLabelEnter.call(setValueLabelEnterAttrs).transition((0, transitions_1.delayedTransition)(params)).call(transitions_1.fadeIn);
      valueLabelUpdate.transition((0, transitions_1.immediateTransition)(params)).call(valueLabelUpdateFirstTransition).transition((0, transitions_1.immediateTransition)(params)).call(valueLabelUpdateSecondTransition);
      valueLabelExit.transition((0, transitions_1.immediateTransition)(params)).call(transitions_1.fadeOut);
    } else {
      valueLabelEnter.call(setValueLabelEnterAttrs).call(transitions_1.fadeIn);
      valueLabelUpdate.call(valueLabelUpdateFirstTransition).call(valueLabelUpdateSecondTransition);
    }
  }
  drawAxis(drawParams) {
    let transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const {
      data,
      params: {
        hideGridlines,
        hideAxisLabels,
        axisTextColor,
        gridColor,
        fontSize,
        margins,
        bottomXTicks,
        xAxisTicks,
        hideDrawLine,
        transitionDuration
      }
    } = drawParams;
    const chartGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    const chartLabelGroup = chartGroup.select(`g.${this.cssPrefix}-labels`);
    const chartAxis = this.svg.select(`g.${this.cssPrefix}-xaxis`);
    // const vertAxisSpacing = 2; // arbitrary value for space between tick text and chart
    const chartAreaLeft = margins.left + margins.labelPadding + chartLabelGroup.node().getBBox().width;
    const [startY, endY] = this.yScale.range();
    const [startX, endX] = this.xScale.range();
    const axisWidth = endX - startX;
    const chartAreaHeight = endY - startY;
    const chartAreaTop = margins.top + margins.valueLabelPadding + chartAreaHeight + this.yScale.bandwidth() / 2;
    let ticks = xAxisTicks;
    if (axisWidth < 150) {
      ticks = 2;
    } else if (axisWidth < 300) {
      ticks = 3;
    }
    let xAxis;
    if (bottomXTicks) {
      xAxis = d3.axisBottom(this.xScale);
    } else {
      xAxis = d3.axisTop(this.xScale);
    }
    let axisVertOffset = fontSize + 1;
    if (bottomXTicks) {
      axisVertOffset = chartAreaTop;
    }
    if (transition && !this.initialDraw) {
      chartAxis.transition().duration(transitionDuration).attr('transform', `translate(${chartAreaLeft}, ${axisVertOffset})`).call(xAxis.tickSize(-(chartAreaTop - margins.top)).tickFormat(t => (0, chart_helpers_1.valueFormat)(drawParams)(t, {
        ticks: this.xScale.ticks(ticks)
      })).ticks(ticks));
      chartAxis.selectAll('.tick text').style('display', hideAxisLabels ? 'none' : null).style('fill', axisTextColor).style('font-size', `${fontSize}px`);
    } else {
      chartAxis.attr('transform', `translate(${chartAreaLeft}, ${axisVertOffset})`).call(xAxis.tickSize(-(chartAreaTop - margins.top)).tickFormat(t => (0, chart_helpers_1.valueFormat)(drawParams)(t, {
        ticks: this.xScale.ticks(ticks)
      })).ticks(ticks)).selectAll('.tick text').style('display', hideAxisLabels ? 'none' : null).style('fill', axisTextColor).style('font-size', `${fontSize}px`);
    }
    chartAxis.selectAll('.tick line').style('display', hideGridlines ? 'none' : null).classed('bold', d => !this.xScale.domain().includes(0) && d === 0).style('stroke', gridColor);
    if (data.length > 0 && !hideDrawLine) {
      this.drawLine(drawParams, chartAreaLeft);
    }
  }
  drawLine(_ref9, left) {
    let {
      data,
      params
    } = _ref9;
    const yValues = data.map(this.yAccessor.bind(this));
    const chartLine = this.svg.select(`g.${this.cssPrefix}-xline`);
    chartLine.style('display', null).selectAll('line').data([0]).join('line').classed('bold', true).style('opacity', !this.xScale.domain().includes(0) ? 1 : 0).style('stroke', params.axisTextColor).attr('x1', d => left + this.xScale(d)).attr('x2', d => left + this.xScale(d)).attr('y1', Math.min(...yValues) - this.yScale.bandwidth() / 2 - 10).attr('y2', Math.max(...yValues) + this.yScale.bandwidth() / 2 + 10);
  }
  drawSectionLines(_ref10) {
    let {
      topMetrics,
      data,
      bottomMetrics,
      params: {
        margins,
        transitionDuration
      }
    } = _ref10;
    let transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const lines = [];
    if (topMetrics.length > 0) {
      const y = (this.yAccessor(topMetrics[topMetrics.length - 1]) + this.yAccessor(data[0])) / 2;
      lines.push(y);
    }
    if (bottomMetrics.length > 0) {
      const y = (this.yAccessor(data[data.length - 1]) + this.yAccessor(bottomMetrics[0])) / 2;
      lines.push(y);
    }
    if (transition && !this.initialDraw) {
      this.svg.selectAll('line.section').data(lines).join(enter => enter.append('line').classed('section', true).style('stroke', colours_module_scss_1.default.chartcolourgrey).style('stroke-width', 2).attr('y1', lodash_1.default.identity).attr('y2', lodash_1.default.identity).attr('x1', margins.left).attr('x2', this.width - margins.right).style('opacity', 0).call(d => d.transition().delay(transitionDuration).duration(transitionDuration).style('opacity', 1)), update => update, exit => exit.call(d => d.transition().duration(transitionDuration).style('opacity', 0).remove()));
    } else {
      this.svg.selectAll('line.section').data(lines).join('line').classed('section', true).style('stroke', colours_module_scss_1.default.chartcolourgrey).style('stroke-width', 2).attr('y1', lodash_1.default.identity).attr('y2', lodash_1.default.identity).attr('x1', margins.left).attr('x2', this.width - margins.right);
    }
  }
  async drawCanvas(dataPromises) {
    let chartOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let {
      margin = 40,
      width = 720,
      scale = 3,
      key = undefined,
      // showText = true,
      showBranding = true,
      xOffset = 0,
      yOffset = 0
    } = arguments.length > 2 ? arguments[2] : undefined;
    let canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, canvas_1.createCanvas)(width, width);
    const allData = await this.data(dataPromises, chartOptions);
    if (!allData) return canvas;
    const {
      data,
      parent,
      topMetrics,
      bottomMetrics
    } = allData;
    const params = this.getDrawParams({
      data,
      parent,
      options: chartOptions
    });
    if (margin !== null) {
      params.margins.left = margin;
      params.margins.right = margin;
    }
    const selectedKey = key || this.dropdownSelected;
    const logoOffset = 20 + margin + 20;
    const titleOffset = params.titleFontSize * parseFloat(common_module_scss_1.default.chartTitleLineHeight);
    const hasSubtitle = params.subtitle !== '';
    const subtitleOffset = hasSubtitle ? params.subtitleFontSize * parseFloat(common_module_scss_1.default.chartSubtitleLineHeight) : 0;
    const footerHeight = (margin ?? 0) + 20;
    const {
      xScale,
      yScale
    } = this.createScales.call(this, data, params, params.margins, params.metricHeight, topMetrics, bottomMetrics);
    const oldWidth = this.width;
    this.width = width;
    // Canvas modification is meant to have side effects
    // eslint-disable-next-line no-param-reassign
    canvas.width = width * scale;
    const chartHeight = params.metricHeight * data.length + params.margins.top + params.margins.bottom;
    // eslint-disable-next-line no-param-reassign
    canvas.height = (chartHeight + logoOffset + titleOffset + subtitleOffset + footerHeight) * scale;
    const context = canvas.getContext('2d');
    context.fillStyle = 'white';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.scale(scale, scale);
    const leftMargin = params.margins.left;
    CanvasDrawer_1.default.drawTitles.call(this, canvas, params, params.hideYear || params.hideDropdown ? null : selectedKey, (0, chart_helpers_1.primaryColour)(params), undefined, undefined, xOffset, yOffset + logoOffset);
    const longestLabelWidth = (0, lodash_1.default)([topMetrics, data, bottomMetrics]).map(d => CanvasDrawer_1.default.drawLeftLabels(canvas, d, params, yScale, width, leftMargin, logoOffset + titleOffset + subtitleOffset)).map('longestLabelWidth').max();
    const spacingForRightLabel = 40;
    xScale.range([params.margins.left + params.margins.labelPadding + longestLabelWidth, width - params.margins.right - spacingForRightLabel]);
    context.strokeStyle = params.axisTextColor;
    const barOffset = logoOffset + titleOffset + subtitleOffset;
    const lineX = xScale(0);
    context.beginPath();
    context.moveTo(lineX, yScale.range()[0] - yScale.bandwidth() / 2 + barOffset);
    context.lineTo(lineX, yScale.range()[1] - yScale.bandwidth() / 2 + barOffset);
    context.stroke();
    const format = (0, chart_helpers_1.valueFormat)({
      data,
      parent,
      params
    });
    if (topMetrics.length > 0) {
      const y = barOffset + this.yAccessor(topMetrics[topMetrics.length - 1]);
      context.strokeStyle = colours_module_scss_1.default.chartcolourgrey;
      context.lineWidth = 2;
      context.beginPath();
      context.moveTo(params.margins.left, y);
      context.lineTo(width - params.margins.right, y);
      context.stroke();
      CanvasDrawer_1.default.drawBars.call(this, canvas, topMetrics, params, selectedKey, xScale, yScale, 0, barOffset, d => (0, chart_helpers_1.primaryColour)(params, d), format);
    }
    CanvasDrawer_1.default.drawBars.call(this, canvas, data, params, selectedKey, xScale, yScale, 0, barOffset, d => (0, chart_helpers_1.primaryColour)(params, d), format);
    if (bottomMetrics.length > 0) {
      const y = barOffset + (this.yAccessor(data[data.length - 1 - bottomMetrics.length]) + this.yAccessor(bottomMetrics[0])) / 2;
      context.strokeStyle = colours_module_scss_1.default.chartcolourgrey;
      context.lineWidth = 2;
      context.beginPath();
      context.moveTo(params.margins.left, y);
      context.lineTo(width - params.margins.right, y);
      context.stroke();
      CanvasDrawer_1.default.drawBars.call(this, canvas, bottomMetrics, params, selectedKey, xScale, yScale, 0, barOffset, d => (0, chart_helpers_1.primaryColour)(params, d), format);
    }
    if (showBranding) {
      await CanvasDrawer_1.default.drawLogo(canvas, width, params, margin);
      CanvasDrawer_1.default.drawFooter(canvas, width, chartHeight + logoOffset + titleOffset + subtitleOffset + 20);
    }
    this.width = oldWidth;
    return canvas;
  }
}
exports.default = BarChart;